module.exports = __webpack_public_path__ + "static/media/Climate_and_health_logo_white.bcd3c421.svg";